export default "__VITE_ASSET__DvKsmTZL__"